module.exports = __webpack_public_path__ + "static/media/ourbusiness_realestate.54bf187d.png";